import styled from 'styled-components'
import ImagePlaceholder from 'Components/ImagePlaceholder'

import {
  GREY_BACKGROUND, CLICKABLE_COLOR, OUTLINE_COLOR,
  TEXT_GREY, SELECTED_ITEM_BG_COLOR, LINK_COLOR,
} from '@CSSVars/colors'

export const _ListingAmenitiesContainer = styled.div`
`

export const _BuildingBanner = styled.div`
  width: 100%;
  height: 210px;
  margin: 48px 0 0;
  background-color: ${GREY_BACKGROUND};
  display: flex;
  align-items: flex-start;
  border-radius: 10px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const _BuildingImage = styled(ImagePlaceholder)`
  width: 300px;
  height: 210px;
  display: inline-flex;
  border-radius: 10px;
  img {
    min-width: 100%;
  }
`

export const _BuildingCopy = styled.div`
  width: calc(100% - 300px);
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 56px;
`

export const _Title = styled.h2`
  color: ${LINK_COLOR};
  line-height: 40px;
  margin-bottom: 8px;
  a {
    font-size: 28px;
    font-weight: 600;
    text-decoration: underline;
    @media (hover: hover){
      &:hover{
        color:${CLICKABLE_COLOR};
      }
    }
    &:active{
      color: ${SELECTED_ITEM_BG_COLOR};
    }
  }
`

export const _AddressName = styled.h2`
  color: ${TEXT_GREY};
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 8px;
`

export const _ListingCounts = styled.div`
  display: flex;

  div, span {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  span {
    color: ${LINK_COLOR};
  }

`

export const _Divider = styled.div`
  margin: 0 12px;
  color: ${OUTLINE_COLOR};
`
